module.exports = __webpack_public_path__ + "img/laying-diagonale-off.4a31d378.svg";